import { Draft } from '@reduxjs/toolkit';

import { ICategoryData } from '../../index';

function getAllToSelectFailure(draft: Draft<ICategoryData>) {
  draft.getAllToSelect.config.isLoading = false;
}

export default getAllToSelectFailure;
